<template>
  <div class="myusers f-s-s f-d-c w-100 p-5">
    <div class="header f-c-c w-100 mb-3">
      <div class="f-c-b searchBox w-100">
        <div class="tableTitle f-c-c">جلسات دعوت شده</div>
        <div class="search f-c-c">
          <input
            v-if="isSearchActive"
            :class="[isSearchActive ? 'searchInputActive' : '']"
            @keyup="searchFunc"
            type="text"
            placeholder="جستجو"
          />
          <b-img
            :class="[isSearchActive ? 'imgActive' : '']"
            :src="require(`@/assets/images/gap/search-icon.svg`)"
            @click="searchIconFunc()"
          ></b-img>
        </div>
      </div>
      <!-- <div class="search f-c-c">
          <b-img :src="require(`@/assets/images/gap/search-icon.svg`)"></b-img>
          <input v-model="searchUser" type="text" placeholder="جستجو" />
        </div> -->
    </div>
    <div class="userTable meetTable f-c-c f-d-c w-100">
      <div class="header f-c-s w-100">
        <div class="headerItem f-c-s"></div>
        <div class="headerItem f-c-s w-30">عنوان</div>
        <!-- <div class="headerItem f-c-s w-20">زمان شروع</div> -->
        <div class="headerItem f-c-s w-20">سازمان</div>
        <div class="headerItem f-c-s w-15">وضعیت</div>
        <div class="headerItem f-c-c w-25">عملیات</div>
      </div>
      <div v-if="itemsForList.length" class="tableContent f-c-c f-d-c w-100">
        <div
          v-for="(v, i) in itemsForList"
          :key="i"
          class="tableRow f-c-s w-100"
        >
          <div class="tableItem f-c-c">{{ v.row }}</div>
          <div class="tableItem f-c-s w-30">
            <span :title="v.title" class="">{{ v.title }}</span>
          </div>
          <!-- <div class="tableItem f-c-s w-20">{{ v.start_date }}</div> -->
          <div class="tableItem f-c-s w-20">
            <span :title="v.organ_title">{{ v.organ_title }}</span>
          </div>
          <div class="tableItem f-c-s w-15">{{ v.status }}</div>
          <div class="tableItem f-c-sa w-25">
            <div
              v-if="user.permissions.show_invited_records_session && v.recordings == 'yes'"
              class="recordIcon f-c-c"
              @click.prevent="showRecordFunc(v)"
            >
              ضبط شده ها
            </div>
            <div v-else style="visibility: hidden">ضبط شده ها</div>
            <div
              v-if="user.permissions.enter_invited_session"
              class="enterIcon f-c-c"
              @click.prevent="showSansFunc(v)"
            >
              ورود
            </div>

            <!-- <b-img
              v-if="user.permissions.enter_invited_session"
              title="ورود"
              @click.prevent="showSansFunc(v)"
              class="enterSessionBtn ml-2"
              :src="require(`@/assets/images/gap/arrow-enter.svg`)"
            ></b-img>
            <b-img
              v-if="user.permissions.show_invited_records_session"
              title="ضبط شده ها"
              @click.prevent="showRecordFunc(v)"
              class="ml-2"
              :src="require(`@/assets/images/gap/record-icon.svg`)"
            ></b-img> -->

            <!-- <b-img
                title="ویرایش"
                @click.prevent="editUserFunc(v)"
                class="ml-2"
                :src="require(`@/assets/images/gap/edit-icon.svg`)"
              ></b-img>
              <b-img
                title="حذف"
                @click.prevent="deleteUserFunc(v)"
                class="ml-2"
                :src="require(`@/assets/images/gap/delete-icon.svg`)"
              ></b-img> -->
          </div>
        </div>
      </div>
      <div v-else class="tableContent emptyTable f-c-c w-100 h-100">
        جلسه ای وجود ندارد.
      </div>
      <div class="paginationSection f-c-c w-100">
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="my-table"
        ></b-pagination>
      </div>
    </div>
    <div v-if="mobileUsers.length" class="mobileUserTable f-c-s f-d-c w-100">
      <div
        v-for="(v, i) in mobileUsers"
        :key="i"
        class="tableItem f-c-s f-d-c w-100 mb-3"
      >
        <div class="up f-c-b w-100 mb-3">
          <div class="right f-s-s f-d-c">
            <div class="labelItem f-c-c mb-2">عنوان :</div>
            <!-- <div class="labelItem f-c-c mb-2">زمان شروع :</div> -->
            <div class="labelItem f-c-c mb-2">سازمان :</div>
            <div class="labelItem f-c-c">وضعیت :</div>
          </div>
          <div class="left f-e-e f-d-c">
            <div class="answerItem f-c-e mb-2">
              {{ v.title }}
            </div>
            <!-- <div class="answerItem f-c-e mb-2">
              {{ v.start_date }}
            </div> -->
            <div class="answerItem f-c-e mb-2">
              {{ v.organ_title }}
            </div>
            <div class="answerItem f-c-e">
              {{ v.status }}
            </div>
          </div>
        </div>
        <div class="down f-c-b w-100">
          <div
            v-if="user.permissions.enter_invited_session"
            class="edit f-c-c w-22"
            @click.prevent="showSansFunc(v)"
          >
            <b-img
              :src="require(`@/assets/images/gap/arrow-enter.svg`)"
            ></b-img>
          </div>
          <div
            v-if="user.permissions.show_invited_records_session && v.recordings == 'yes'"
            class="edit f-c-c w-22"
            @click.prevent="showRecordFunc(v)"
          >
            <b-img
              :src="require(`@/assets/images/mobile/record-icon.svg`)"
            ></b-img>
          </div>
          <!-- <div class="edit f-c-c w-22" @click.prevent="editUserFunc(v)">
              <b-img
                :src="require(`@/assets/images/mobile/edit-pen.svg`)"
              ></b-img>
            </div>
            <div class="delete f-c-c w-22" @click.prevent="deleteUserFunc(v)">
              <b-img
                :src="require(`@/assets/images/mobile/delete-x.svg`)"
              ></b-img>
            </div> -->
        </div>
      </div>
    </div>
    <div
      v-else
      class="mobileUserTable tableContent emptyTable f-c-c w-100 h-100"
    >
      جلسه ای وجود ندارد.
    </div>
    <b-modal
      id="sans-modal"
      title="سانس ها"
      size="lg"
      button-size="sm"
      :hide-footer="footer"
      ref="sans-modal"
    >
      <template class="content f_s_s f-d-c w-100">
        <div class="addUserBox addUserBoxStep2 f-c-s f-d-c w-100 mb-2">
          <div class="userTable meetTable f-c-c f-d-c w-100">
            <div class="header f-c-s w-100">
              <div class="headerItem f-c-s"></div>
              <div class="headerItem f-c-s">تاریخ</div>
              <div class="headerItem f-c-s w-22">ساعت</div>
              <div class="headerItem f-c-s w-16">توضیحات</div>
              <div class="headerItem f-c-c w-22">عملیات</div>
            </div>
            <div v-if="sanses.length" class="tableContent f-c-c f-d-c w-100">
              <div
                v-for="(v, i) in sanses"
                :key="i"
                class="tableRow f-c-s w-100"
                :class="[
                  v.flag == 'green'
                    ? 'activeGreen'
                    : v.flag == 'red'
                    ? 'activeRed'
                    : 'activeYellow',
                ]"
              >
                <div class="tableItem f-c-c">{{ v ? v.row : "" }}</div>
                <div class="tableItem f-c-s">{{ v.date_from }}</div>
                <div class="tableItem f-c-s w-22">
                  {{
                    v
                      ? v.time_from.split(":")[0] +
                        ":" +
                        v.time_from.split(":")[1] +
                        " " +
                        "تا" +
                        " " +
                        v.time_to.split(":")[0] +
                        ":" +
                        v.time_to.split(":")[1]
                      : ""
                  }}
                </div>
                <div class="tableItem f-c-s w-16">
                  {{ v ? v.status : "" }}
                </div>
                <div class="tableItem f-c-c w-22">
                  <a
                    v-if="v.flag == 'white' && v.url"
                    @click="goToSessionFunc('https://vadaroom.ec.iau.ir/v/' + v.url)"
                    class="enterSission f-c-c"
                    >ورود</a
                  >
                  <div v-else class="enterSission disabledBtn f-c-c">ورود</div>

                  <b-img
                    v-if="v.url"
                    title="کپی لینک"
                    style="width: 20px; margin-right: 1rem"
                    class="cp"
                    @click="copy('https://vadaroom.ec.iau.ir/v/' + v.url)"
                    :src="require(`@/assets/images/gap/link-blue.svg`)"
                  ></b-img>
                  <b-img
                    v-else
                    style="width: 20px; margin-right: 1rem"
                    title="کپی لینک"
                    :src="require(`@/assets/images/gap/link-gray.svg`)"
                  ></b-img>
                </div>
              </div>
            </div>
            <div v-else class="tableContent emptyTable f-c-c w-100 h-100">
              سانسی وجود ندارد.
            </div>
          </div>
        </div>
      </template>
    </b-modal>
    <DeleteConfirm v-if="isDeletee" message="از حذف جلسه مطمئن هستید ؟" />
  </div>
</template>
  <script>
import { mapState, mapActions } from "vuex";
import DeleteConfirm from "@/components/DelConfirmModal";
import { EventBus } from "@/assistant/EventBus";
export default {
  name: "InvitedMeetings",
  data() {
    return {
      footer: true,
      isSearchActive: false,
      searchUser: "",
      appId: "3493993048904",
      canCopy: false,
      currentPage: 1,
      isDeletee: false,
      deleteSession: {},
      editSession: {},
      perPage: 15,
      iswatie: false,
      users: [],
      mobileUsers: [],
      sanses: [],
    };
  },
  created() {
    this.canCopy = !!navigator.clipboard;
    this.getAllInvitedSessionFunction({
      user_id: this.user.user_id,
    });
    EventBus.$on("deleteItem", (status) => {
      if (status && this.isDeletee) {
        this.deleteSessionFunction({
          user_id: this.user.user_id,
          session_id: this.deleteSession.id,
        });
      }
      this.isDeletee = false;
    });
  },
  components: {
    DeleteConfirm,
  },
  computed: {
    ...mapState({
      user: (state) => state.gap.user,
      allInvitedSession: (state) => state.gap.allInvitedSession,
      deleteSessionStatus: (state) => state.gap.deleteSessionStatus,
      sessionInfo: (state) => state.gap.sessionInfo,
      allSans: (state) => state.gap.allSans,
      allSansRecord: (state) => state.gap.allSansRecord,
      allSansRecordStatus: (state) => state.gap.allSansRecordStatus,
    }),
    rows() {
      return this.users.length;
    },
    itemsForList() {
      return this.users.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
  },
  methods: {
    ...mapActions("gap", [
      "getAllInvitedSessionFunction",
      "deleteSessionFunction",
      "getSessionInfoFunction",
      "getAllSansFunction",
      "setAppTitleFunction",
      "setSessionRoutFunction",
      "setDirectEntryFunction"
    ]),
    searchFunc(v){
      let n = v.target.value
      let searchArray = this.allInvitedSession.sessions.filter((ticket) => {
        return (
          ticket.title.toLowerCase().includes(n) ||
          ticket.organ_title.toLowerCase().includes(n) ||
          ticket.status.toLowerCase().includes(n)
        );
      });
      this.users = searchArray;
      this.mobileUsers = searchArray;
    },
    goToSessionFunc(url) {
      this.setDirectEntryFunction(true)
      setTimeout(() => {
        window.location.href = url;
      }, 100);
      
    },
    searchIconFunc() {
      this.isSearchActive = !this.isSearchActive;
      setTimeout(() => {
        if (this.isSearchActive) {
          document.querySelector(".searchInputActive").focus();
        }
      }, 200);
    },
    showRecordFunc(v) {
      // this.$router.push({ name: "records" });
      this.getAllSansFunction({
        user_id: this.user.user_id,
        session_id: v.id,
        record: true,
        el: v,
      });
    },
    showSansFunc(v) {
      this.$refs["sans-modal"].show();
      this.getAllSansFunction({
        user_id: this.user.user_id,
        session_id: v.id,
      });
    },
    async copy(s) {
      await navigator.clipboard.writeText(s);
      this.$bvToast.toast("کپی لینک با موفقیت انجام گردید.", {
        title: "کپی",
        variant: "success",
        solid: true,
      });
    },
    editUserFunc(v) {
      this.getSessionInfoFunction({
        user_id: this.user.user_id,
        session_id: v.id,
      });
    },
    deleteUserFunc(v) {
      this.isDeletee = true;
      this.deleteSession = v;
    },
    addNewSissionFunc() {
      this.setAppTitleFunction("افزودن جلسه");
      this.$router.push({ name: "addNewSission1" });
    },
  },
  watch: {
    allSansRecord(n) {
      setTimeout(() => {
        if (this.allSansRecordStatus.code == 100) {
          this.setSessionRoutFunction("invited");
          this.$router.push({ name: "records" });
        } else if (this.allSansRecordStatus.code == 503 && n == undefined) {
          this.$bvToast.toast(this.allSansRecordStatus.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }, 200);
    },
    allSans(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.sanses = n.session_sanses;
        }
      }
    },
    sessionInfo(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.$router.push({ name: "sessionDetails" });
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    deleteSessionStatus(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.getAllSessionFunction({
            user_id: this.user.user_id,
          });
          this.$bvToast.toast(n.message, {
            title: "تایید",
            variant: "success",
            solid: true,
          });
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    allInvitedSession(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.users = n.sessions;
          this.mobileUsers = n.sessions;
        } else {
          this.users = [];
          this.mobileUsers = [];
          this.iswatie = true;
        }
      }
    },
    searchUser(n) {
      let searchArray = this.allInvitedSession.sessions.filter((ticket) => {
        return (
          ticket.title.toLowerCase().includes(n) ||
          ticket.start_date.toLowerCase().includes(n) ||
          ticket.status.toLowerCase().includes(n)
        );
      });
      this.users = searchArray;
      this.mobileUsers = searchArray;
    },
  },
  mounted() {
    if (Object.keys(this.allInvitedSession).length) {
      if (this.allInvitedSession.code == 100) {
        this.users = this.allInvitedSession.sessions;
        this.mobileUsers = this.allInvitedSession.sessions;
      } else {
        this.iswatie = true;
      }
    }
  },
};
</script>